if (!window.__cartTryonDrawerInitialized) {
  window.__cartTryonDrawerInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('[data-tryon-drawer]');
    if (!drawer) return;

    // 同じスニペットが複数回描画された場合の重複要素を掃除する
    var existingDrawers = document.querySelectorAll('[data-tryon-drawer]');
    if (existingDrawers.length > 1) {
      for (var i = 1; i < existingDrawers.length; i++) {
        existingDrawers[i].remove();
      }
    }

    // 祖先要素のスタッキングコンテキスト/overflow指定の影響を避けるため body 直下へ移動
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 300);
    }

    document.querySelectorAll('[data-tryon-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    drawer.querySelectorAll('[data-tryon-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  });
}
